import { useEffect, useMemo, useState } from "react";
import {
  DEFAULT_PLATFORM_LOGO_PATH,
  PLATFORM_LOGO_UPDATED_EVENT,
  fetchPublicPlatformLogoPath,
  isCustomPlatformLogoPath,
  resolvePlatformLogoUrl,
} from "../services/platformLogo.service";

function usePlatformLogoPath() {
  const [logoPath, setLogoPath] = useState(DEFAULT_PLATFORM_LOGO_PATH);

  useEffect(() => {
    let active = true;

    const load = (bypassCache = false) => {
      void fetchPublicPlatformLogoPath({ bypassCache }).then((path) => {
        if (active && path) setLogoPath(path);
      });
    };

    load();

    const onUpdated = (event) => {
      const nextPath = event?.detail?.path;
      if (nextPath) {
        setLogoPath(nextPath);
        return;
      }
      load(true);
    };

    window.addEventListener(PLATFORM_LOGO_UPDATED_EVENT, onUpdated);
    return () => {
      active = false;
      window.removeEventListener(PLATFORM_LOGO_UPDATED_EVENT, onUpdated);
    };
  }, []);

  return logoPath;
}

export default function usePlatformLogo({ variant = "default" } = {}) {
  const logoPath = usePlatformLogoPath();
  return useMemo(
    () => resolvePlatformLogoUrl(logoPath, { variant }),
    [logoPath, variant]
  );
}

export function usePlatformLogoMeta({ variant = "default" } = {}) {
  const logoPath = usePlatformLogoPath();
  return useMemo(
    () => ({
      logoUrl: resolvePlatformLogoUrl(logoPath, { variant }),
      isCustomLogo: isCustomPlatformLogoPath(logoPath),
    }),
    [logoPath, variant]
  );
}
